module.exports = __webpack_public_path__ + "img/rhodium@2x.726eaca.jpg";